class FsrFilterBarCp extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this._attachSelectors();
        this._attachListeners();
    }

    _attachSelectors() {
        this.productCards = document.querySelectorAll('.fsr-product-card');
    }

    _attachListeners() {
        this.addEventListener('click', event => this._setFilterItemState(event));
    }

    _setFilterItemState(event) {
        if (event.target.classList.contains('filter-item')) {
            this.querySelectorAll('.filter-item').forEach(item => {
                item.classList.remove('active-filter');
            });
            event.target.classList.add('active-filter');

            this._filterItems(event.target.dataset.filterTag);
        }
    }

    _filterItems(filterTag) {
        this.productCards.forEach(card => {
            card.style.opacity = '0';
        });

        setTimeout(() => {
            this.productCards.forEach(card => {
                const shouldShow = filterTag === 'Alle' || card.dataset.filterTags.includes(filterTag);
                card.style.display = shouldShow ? '' : 'none';
                card.style.opacity = shouldShow ? '1' : '0';
            });
        }, 300);
    }
}

customElements.define('fsr-filter-bar-cp', FsrFilterBarCp);
